<!-- Putting the message as an innerHTML preserves any html tags in the message for styling like linebreaks.
  As a developer make sure that only precanned messages are used so as to not allow erroneous or bad html tags -->

<div  *ngIf="message"
  [ngClass]="{ 'alert': message, 'alert-success-blue': message.type === 'success', 'alert-danger': message.type === 'error' }"
  [innerHTML]="message.text | safeHtml"
></div>
